import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import EinsatzView from '../views/EinsatzView.vue'
import HydrantenView from '../views/Einsatz/HydrantenView.vue'
import HilfeImWald from '../views/Einsatz/HilfeImWald.vue'
import GefahrgutView from '../views/Einsatz/GefahrgutView.vue'
import LernView from '../views/LernView.vue'
import LeistungspruefungTHL from '../views/Lernen/LeistungspruefungTHL.vue'
import LeistungspruefungWasser from '../views/Lernen/LeistungspruefungWasser.vue'
import Benutzerverwaltung from '../views/Administrator/Benutzerverwaltung.vue'
import Defaultwerte from '../views/Defaultwerte.vue'
import FahrzeugVerwaltung from '../views/Administrator/FahrzeugVerwaltung.vue'
import What3Words from '@/views/Einsatz/What3Words.vue'
import Sammelpunkte from '@/views/Einsatz/Sammelpunkte.vue'
import WEANIS from '@/views/Einsatz/WEA-NIS.vue'
import FunkView from '@/views/Einsatz/FunkView.vue'
import Geraeteverwaltung from '@/views/Administrator/Geraeteverwaltung.vue'
import Quiz from '@/views/Lernen/Quiz.vue'
import Datenschutz from '@/views/Datenschutz.vue'
import UeberDieApp from '@/views/UeberDieApp.vue'
import LPTHLTruppaufgabe from '@/views/Lernen/LP-THLTruppaufgabe.vue'
import Mehr from '@/views/Mehr.vue'
import Kassensystem from '@/views/WeitereApps/Kassensystem.vue'
import MTA2Praxis from '@/views/Lernen/MTA2Praxis.vue'
import GWL from '@/views/Lernen/GWL.vue'
import Waldbrand from '@/views/Lernen/Waldbrand.vue'
import ViewAuswahl from '@/views/ViewAuswahl.vue'
import FeuerwehrVerwaltung from '@/views/Administrator/FeuerwehrVerwaltung.vue'
import Eurorescue from '@/views/Einsatz/Eurorescue.vue'
import Atemschutz from '@/views/Lernen/Atemschutz.vue'
import LPTHLLernstoff from '@/views/Lernen/LP-THLLernstoff.vue'
import LPTHLSprueche from '@/views/Lernen/LP-THLSprueche.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '//:id',
    name: 'home2',
    component: HomeView
  },
  {
    path: '/home/:id',
    name: 'home',
    component: HomeView
  },
  {
    path: '/einsatz/:id',
    name: 'einsatz',
    component: EinsatzView
  },
  {
    path: '/hydranten/:id',
    name: 'hydranten',
    component: HydrantenView
  },
  {
    path: '/hilfeimwald/:id',
    name: 'hilfeimwald',
    component: HilfeImWald
  },
  {
    path: '/gefahrgut/:id',
    name: 'gefahrgut',
    component: GefahrgutView
  },
  {
    path: '/lern-hub/:id',
    name: 'lern-hub',
    component: LernView
  },
  {
    path: '/leistungspruefung-thl/:id',
    name: 'leistungspruefung-thl',
    component: LeistungspruefungTHL
  },
  {
    path: '/leistungspruefung-wasser/:id',
    name: 'leistungspruefung-wasser',
    component: LeistungspruefungWasser
  },
  {
    path: '/benutzerverwaltung/:id',
    name: 'benutzerverwaltung',
    component: Benutzerverwaltung
  },
  {
    path: '/defaultwerte/:id',
    name: 'defaultwerte',
    component: Defaultwerte
  },
  {
    path: '/fahrzeugverwaltung/:id',
    name: 'fahrzeugverwaltung',
    component: FahrzeugVerwaltung
  },
  {
    path: '/what3words/:id',
    name: 'what3words',
    component: What3Words
  },
  {
    path: '/sammelpunkte/:id',
    name: 'sammelpunkte',
    component: Sammelpunkte
  },
  {
    path: '/wea-nis/:id',
    name: 'wea-nis',
    component: WEANIS
  },
  {
    path: '/funk/:id',
    name: 'funk',
    component: FunkView
  },
  {
    path: '/geraeteverwaltung/:id',
    name: 'geraeteverwaltung',
    component: Geraeteverwaltung
  },
  {
    path: '/quiz/:id/:quizID',
    name: 'quiz',
    component: Quiz
  },
  {
    path: '/datenschutz/:id',
    name: 'datenschutz',
    component: Datenschutz
  },
  {
    path: '/ueberDieApp/:id',
    name: 'ueberDieApp',
    component: UeberDieApp
  },
  {
    path: '/lpthl-truppaufgabe/:id',
    name: 'lpthl-truppaufgabe',
    component: LPTHLTruppaufgabe
  },
  {
    path: '/mehr/:id',
    name: 'mehr',
    component: Mehr
  },
  {
    path: '/kassensystem/:id',
    name: 'kassensystem',
    component: Kassensystem
  },
  {
    path: '/mta2-praxis/:id',
    name: 'mta2-praxis',
    component: MTA2Praxis
  },
  {
    path: '/gwl-2/:id',
    name: 'gwl-2',
    component: GWL
  },
  {
    path: '/waldbrand/:id',
    name: 'waldbrand',
    component: Waldbrand
  },
  {
    path: '/auswahl/:id',
    name: 'auswahl',
    component: ViewAuswahl
  },
  {
    path: '/feuerwehrverwaltung/:id',
    name: 'feuerwehrverwaltung',
    component: FeuerwehrVerwaltung
  },
  {
    path: '/eurorescue/:id',
    name: 'eurorescue',
    component: Eurorescue
  },
  {
    path: '/atemschutz/:id',
    name: 'atemschutz',
    component: Atemschutz
  },
  {
    path: '/lp-thl-infos/:id',
    name: 'lp-thl-infos',
    component: LPTHLLernstoff
  },
  {
    path: '/lp-thl-sprueche/:id',
    name: 'lp-thl-sprueche',
    component: LPTHLSprueche
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
